import MUITypography from "@mui/material/Typography";
import * as React from "react";

const Typography = ({ visible = true, children, sx, ...rest }) => {
  if (!visible) return null;
  return (
    <MUITypography sx={sx} {...rest}>
      {children}
    </MUITypography>
  );
};

export default Typography;
